export default {
  header: {
    title: 'Iberpix',
    subtitle: 'Ortofotos y cartografía del IGN',
    change_language: 'Cambiar idioma',
    accept: 'Aceptar',
    help: 'Ayuda',
  },
  visor: {
    coordinates: 'Coordenadas',
    zoom_extent: 'Zoom a la extensión del mapa',
    share_url: 'Compartir URL',
    copied: 'Copiado',
    accept: 'Aceptar',
    copy: 'Copiar',
    printed: 'Impresión generada desde IBERPIX',
    canary: 'Islas Canarias',
    balearic: 'Illes Balears',
    melilla: 'Melilla',
    ceuta: 'Ceuta',
    peninsula: 'Península',
    map: 'Mapa',
    image: 'Imagen',
    street_map: 'Callejero',
    hybrid: 'Híbrido',
    lidar: 'LiDAR (Relieve)',
    toponyms: 'Topónimos',
    corine: 'Ocupación del suelo',
    historic: 'Mapas Históricos',
    info: 'Información',
    close: 'Cerrar',
    welcome: 'Bienvenido a la versión 5.0 del visualizador Iberpix.',
    help: 'Puede consultar la ayuda en el siguiente <a tabindex="0" href="/iberpix/help" target="_blank" rel="noopener noreferrer">enlace</a>.',
    old_here: 'Si desea seguir utilizando la <a tabindex="0" href="https://www.ign.es/iberpixhistorico/" target="_blank" rel="noopener noreferrer">versión anterior</a> de Iberpix estará accesible durante unos meses.',
    print_info: 'La impresión en Iberpix utiliza servicios de mapas externos y es posible, que en función de la resolución solicitada, el formato, los mapas cargados o un mayor uso del sistema en este momento, no pueda llevarse a cabo. Si esto sucede, por favor, inténtelo más tarde.',
    popup: 'Popup Información'
  },
  tree: {
    search: 'Buscar',
    type_here: 'Escribe aquí...',
    clear: 'Limpiar',
    please_characters: 'Por favor, introduce al menos 3 caracteres para realizar una búsqueda',
  },
};
